import { isValid } from "date-fns";

class InputValidators {
    public IsValidDateText(dateString: string): boolean {
        // Expecting a string in the format 00/00/0000
        // Generic validation on whether the string value *could* be a valid date
        let validDate: boolean = true;
        let dateSegments: string[] = dateString.split('/');
        let dateObject: Date = new Date(+dateSegments[2], (+dateSegments[0] - 1), +dateSegments[1]);
        
        validDate = dateSegments.length === 3 && dateSegments[2].length === 4
                    && isValid(dateObject);

        return validDate;
    }

    public IsValidSSN(ssn: string): boolean {
        // Expecting a string in the format 000-00-0000
        let validSSN: boolean = true;
        let ssnSegments: string[] = ssn.split('-');

        validSSN = ssnSegments.length === 3 && ssnSegments[0].length === 3 && ssnSegments[1].length === 2 && ssnSegments[2].length === 4
        return validSSN;
    }

    public IsValidEIN(ein: string): boolean {
        // Expecting a string in the format 00-0000000
        let validEIN: boolean = true;
        let einSegments: string[] = ein.split('-');

        validEIN = einSegments.length === 2 && einSegments[0].length === 2 && einSegments[1].length === 7
        return validEIN;
    }

    public IsValidZipCode(zip: string): boolean {
        // Expecting a number, 5 digits long
        let validZip: boolean = true;

        validZip = zip.length === 5;
        return validZip;
    }

    public IsValidEmailAddress(email: string): boolean {
        // Expecting __@__.__
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    public IsValidPhoneNumber(phone: string): boolean {
        // Expecting (123)-456-7890
        let validPhone = true;
        let phoneSegments: string[] = phone.split('-');

        validPhone = phoneSegments.length === 3 && phoneSegments[0].length === 5 && phoneSegments[1].length === 3 && phoneSegments[2].length === 4;
        return validPhone;
    }

    public IsValidPassword(password: string): boolean {
        // Password needs 1 lowercase, 1 uppercase, 1 number, and 1 special character
        // 1 lowercase: (?=.*[a-z])
        // 1 uppercase: (?=.*[A-Z])
        // 1 number: (?=.*[0-9])
        // 1 special: (?=.*[!@#$%^&*])
        // 8 characters long: (?=.{8,})
        var regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        return regex.test(password);
    }
}

const inputValidators = new InputValidators();
export default inputValidators;